import { apiGet } from "helpers/Request";
import { transform as workflowTransformer } from "schemas/Workflow";
import { transform as collectionTransformer } from "schemas/Collection";
import { getPublicationCode, getPublicationUuid } from "helpers/Auth";
import { transform as channelTransformer } from "schemas/Channel";

export const CONTENT_FLOW_SET_WORKFLOWS = "CONTENT_FLOW_SET_WORKFLOWS";
export const CONTENT_FLOW_SET_META_DEFINITIONS =
    "CONTENT_FLOW_SET_META_DEFINITIONS";
export const CONTENT_FLOW_SET_LAYOUT_TEMPLATES =
    "CONTENT_FLOW_SET_LAYOUT_TEMPLATES";
export const CONTENT_FLOW_SET_SSTS_VALUES = "CONTENT_FLOW_SET_SSTS_VALUES";
export const CONTENT_FLOW_SET_GENERAL_SETTINGS =
    "CONTENT_FLOW_SET_GENERAL_SETTINGS";
export const CONTENT_FLOW_SET_SETTING_PANELS =
    "CONTENT_FLOW_SET_SETTING_PANELS";
export const CONTENT_FLOW_SET_COLLECTIONS = "CONENT_FLOW_SET_COLLECTIONS";

export function getWorkflows() {
    return (dispatch) => {
        return apiGet("/v4/workflow", {
            uuid: getPublicationUuid(),
            client_code: getPublicationCode(),
        }).then((resp) => {
            return dispatch(setWorkflows(workflowTransformer(resp)));
        });
    };
}

export function getCollections() {
    return (dispatch) => {
        return apiGet(
            "/v4/collection",
            {
                uuid: getPublicationUuid(),
                client_code: getPublicationCode(),
            },
            {
                sort: "name",
                dir: "asc",
            }
        ).then((resp) => {
            return dispatch(setCollections(collectionTransformer(resp)));
        });
    };
}

export function getMetaDefinitions() {
    return (dispatch) => {
        return apiGet("/v4/content/info/properties", {
            uuid: getPublicationUuid(),
            client_code: getPublicationCode(),
        }).then((resp) => {
            return dispatch(setMetaDefinitions(resp));
        });
    };
}

export function getLayoutTemplates() {
    return (dispatch) => {
        return apiGet("/v4/content/info/layouts", {
            uuid: getPublicationUuid(),
            client_code: getPublicationCode(),
        }).then((resp) => {
            return dispatch(setLayoutTemplates(resp));
        });
    };
}

export function getSstsValues() {
    return (dispatch) => {
        return apiGet(
            "/v4/ssts",
            {
                uuid: getPublicationUuid(),
                client_code: getPublicationCode(),
            },
            {
                per_page: 500,
            }
        ).then((resp) => {
            return dispatch(setSstsValues(resp));
        });
    };
}

export function getGeneralSettings() {
    return (dispatch) => {
        return apiGet("/v4/setting", {
            uuid: getPublicationUuid(),
            client_code: getPublicationCode(),
        }).then((resp) => {
            return dispatch(setGeneralSettings(resp));
        });
    };
}

export function getSettingPanels() {
    const settingsOnly = ["apple-news", "seo-settings"];

    return (dispatch) => {
        return apiGet(
            "/v4/channel",
            {
                uuid: getPublicationUuid(),
                client_code: getPublicationCode(),
            },
            { include: ["settings"] }
        ).then((resp) => {
            const panels = channelTransformer(resp).filter(
                (channel) =>
                    channel.settings_panel &&
                    settingsOnly.indexOf(channel.slug) === -1
            );
            return dispatch(setSettingPanels(panels));
        });
    };
}

export function setWorkflows(workflows) {
    return {
        type: CONTENT_FLOW_SET_WORKFLOWS,
        payload: {
            items: workflows,
        },
    };
}

export function setCollections(collections) {
    return {
        type: CONTENT_FLOW_SET_COLLECTIONS,
        payload: {
            items: collections,
        },
    };
}

export function setMetaDefinitions(definitions) {
    return {
        type: CONTENT_FLOW_SET_META_DEFINITIONS,
        payload: {
            items: definitions,
        },
    };
}

export function setLayoutTemplates(templates) {
    return {
        type: CONTENT_FLOW_SET_LAYOUT_TEMPLATES,
        payload: {
            items: templates,
        },
    };
}

export function setSstsValues(values) {
    return {
        type: CONTENT_FLOW_SET_SSTS_VALUES,
        payload: {
            items: values,
        },
    };
}

export function setGeneralSettings(values) {
    return {
        type: CONTENT_FLOW_SET_GENERAL_SETTINGS,
        payload: {
            items: values,
        },
    };
}

export function setSettingPanels(values) {
    return {
        type: CONTENT_FLOW_SET_SETTING_PANELS,
        payload: {
            items: values,
        },
    };
}

export function initializeContentFlow() {
    return (dispatch) => {
        const promises = [
            dispatch(getWorkflows()),
            dispatch(getCollections()),
            dispatch(getMetaDefinitions()),
            dispatch(getLayoutTemplates()),
            dispatch(getSstsValues()),
            dispatch(getGeneralSettings()),
            dispatch(getSettingPanels()),
        ];
        return Promise.all(promises);
    };
}
